// extracted by mini-css-extract-plugin
var _1 = "BulletList-moduleBulletList__ikUo_";
var _2 = "BulletList-moduleitem__V1b_a BulletItem-moduleBulletItem__UXnjY";
export { _1 as "BulletList", _2 as "item" }
